<template>
  <div id="app">
    <router-view />
    <!-- The loader lives in public/index.html as a single persistent overlay;
         components hold it open via <Loader v-if="..." />. -->
    <!-- <TemplateRenderer /> -->
  </div>
</template>
<script setup>
import Swiper from "swiper";
import { EffectCoverflow, Navigation, Keyboard } from "swiper/modules";
// import 'swiper/css';
// import 'swiper/css/effect-coverflow';
// import 'swiper/css/navigation';

Swiper.use([EffectCoverflow, Navigation, Keyboard]);
</script>
<script>
import TemplateRenderer from "./views/TemplateRenderer.vue";
import ProjectTemplate1 from "./components/ProjectTemplate1.vue";
import AOS from "aos";
import { getCurrentProjectUser } from "@/services/currentUser";
import { isLoginRemoved } from "@/services/authControl";
// import "aos/dist/aos.css";

export default {
  name: "App",
  components: {
    TemplateRenderer,
    ProjectTemplate1,
  },
  data() {
    return {
      userFound: false,
      userName: "",
      userEmail: ""
    }
  },
  async mounted() {
    // await authenticateUser()

    if (window.location.hash === "#/training/validate" || window.location.hash === "#training/validate") {
      await this.$router.push('/training/finance');

    }

    // F5: removed a pair of chained network calls that did nothing.
    //
    // This block called catalyst.auth.generateAuthToken() and then GET
    // /server/MEASlateServer/, assigned the response to getProjectDetailsResp,
    // and never read it. Two round trips per page load for a discarded result
    // — and the MEASlateServer call was the 997ms time-to-first-byte the audit
    // flagged as a cold serverless start.
    //
    // It was also hardcoded to the *development* host
    // (measolutions-...development.catalystserverless.in), so in production it
    // was calling across into the dev environment. Together with the leftover
    // "Error trying zoho with passing token as header" log, this was clearly
    // experimental code that was never removed.
    //
    // If a real need for MEASlateServer turns up, reinstate it deriving the
    // host from window.location.origin the way the Vuex store does, and
    // actually use the response.
  },
  methods: {
    async authenticateUser() {
			try {
				var currentUserPromise = await getCurrentProjectUser();
				this.userFound = true;
        if (currentUserPromise.content.first_name) {
          this.userName = currentUserPromise.content.first_name;
        }
        if (currentUserPromise.content.last_name) {
          this.userName += " " + currentUserPromise.content.last_name;
        }
				this.userEmail = currentUserPromise.content.role_details.role_name;

        // console.log("Authenticated: ", currentUserPromise);
        // console.log("Authenticated: ", currentUserPromise.content);
      } catch (e) {
        // console.log("Authentication Error: ", e);
        // Same AUTH_CONTROL exemption as the header — see services/authControl.js.
        if (isLoginRemoved()) {
          this.userFound = false;
          return;
        }
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style>
/* .zsiq-flexM, .zsiq-iflexM {
    display: block !important;
  } */
</style>